import { RecordableEvent, addDomainMetadataToObjectWithUrlField, HasTab } from "../../lib/Events";
import { urlToURL } from "../../lib/utils/domains";
import type { UUID, EventMetadataParameter, EventReadyToWriteToDb, HasRecordingUuid, NetworkEventAugmentedFields } from "./DatabaseTypes";


export const recordableEventToEventReadyToWriteToDb = <EVENT extends RecordableEvent>(
	recordingUuid: UUID,
	event: EVENT & HasTab,
	options: EventMetadataParameter = {}
): EventReadyToWriteToDb<EVENT> => {
	const hasRecordingUuid: HasRecordingUuid = { recordingUuid: recordingUuid };
	const tab = { tab: addDomainMetadataToObjectWithUrlField(event.tab)};
	const destination = ("destination" in event ? { destination: addDomainMetadataToObjectWithUrlField(event.destination) } : {});
	const initiator = options.initiator ?? (
		"initiator" in event.raw ? event.raw.initiator : undefined
	);
	const initiatorOrigin = initiator == null ? undefined :
		typeof initiator === "string" ? initiator :
			initiator?.url != null ? urlToURL(initiator.url)?.hostname :
				undefined;
	const hasInitiatorOrigin = initiatorOrigin == null ? {} : { initiatorOrigin: initiatorOrigin satisfies NetworkEventAugmentedFields["initiatorOrigin"] };
	return { 
		...event,
		...hasRecordingUuid,
		...hasInitiatorOrigin,
		...tab,
		...destination
	} as EventReadyToWriteToDb<EVENT>;
};
